module.exports = __webpack_public_path__ + "img/portugal-cerebrovascular-disease-male.08ad53ce.png";